import '../styles/Rdashboard.css';

const MiniCard = ({ label, value }) => {
  return (
    <div className="mini-card">
      <p className="mini-card-label">{label}</p>
      <p className="mini-card-value text-xl md:text-2xl">{value}</p>
    </div>
  );
};

export default MiniCard;